export default "__VITE_ASSET__BDqCVA0Y__"